<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Cliente também ser Subcliente</mat-card-title>
    </div>
    <!--    <button class="btn-icon" (click)="close()">-->
    <!--      <mat-icon>close</mat-icon>-->
    <!--    </button>-->
    <button mat-flat-button class="btn-tg-cancel w-1/12" (click)="close()">
      Voltar
    </button>
    <button
      mat-flat-button
      class="btn-tg w-1/12"
      [disabled]="!checkInvalidForm()"
      (click)="transformClient()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Concluir
      }
    </button>
  </mat-card-header>

  <div class="mt-4 mb-2"></div>

  @if (!loadingScreen) {
    <mat-accordion multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Cliente</h4> </mat-panel-title>
        </mat-expansion-panel-header>

        <!--        <mat-form-field class="input-tg w-1/5" appearance="outline">-->
        <!--          <mat-label>Tipo Cliente</mat-label>-->
        <!--          <mat-select [(value)]="typeClient">-->
        <!--            @for (type of listTypeClient; track type) {-->
        <!--              <mat-option [value]="type.id">{{ type.description }}</mat-option>-->
        <!--            }-->
        <!--          </mat-select>-->
        <!--        </mat-form-field>-->
        <div [formGroup]="formLegalEntity" [hidden]="typeClient != 'legal'">
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-4/12" appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput formControlName="name" readonly />
            </mat-form-field>

            <mat-form-field class="input-tg w-5/12" appearance="outline">
              <mat-label>Razão social</mat-label>
              <input matInput formControlName="corporate_name" readonly />
            </mat-form-field>

            <mat-form-field class="input-tg w-3/12" appearance="outline">
              <mat-label>CNPJ</mat-label>
              <input
                matInput
                formControlName="cnpj"
                [mask]="'99.999.999/9999-99'" readonly
              />
            </mat-form-field>
          </div>
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-6/12" appearance="outline">
              <mat-label>Inscrição Estadual</mat-label>
              <input matInput formControlName="reg_state"  readonly/>
            </mat-form-field>

            <mat-form-field class="input-tg w-6/12" appearance="outline">
              <mat-label>Inscrição Municipal</mat-label>
              <input matInput formControlName="reg_municipal"  readonly/>
            </mat-form-field>
          </div>
        </div>
        <div [formGroup]="formIndividual" [hidden]="typeClient != 'individual'">
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-10/12" appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput formControlName="name"  readonly/>
            </mat-form-field>

            <mat-form-field class="input-tg w-2/12" appearance="outline">
              <mat-label>CPF</mat-label>
              <input matInput formControlName="cpf" [mask]="'999.999.999-99'"  readonly/>
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelSubClient = true">
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Cliente</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        @if (panelSubClient) {
          <div>
            <associate-client-new
              [clientInfo]="item"
              (response)="getList($event, 'client')"
            />
<!--            <associate-client-create-->
<!--              (response)="getList($event, 'client')"-->
<!--            />-->
          </div>
        }
      </mat-expansion-panel>
    </mat-accordion>

  } @else {
    <div class="m-auto">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  }
</mat-card>
